import AboutSection from '../../sections/AboutSection';
import VisorSection from '../../sections/VisorSection';
import FasesSection from '../../sections/FasesSection';
import Gallery from '../../sections/Gallery';
import Descargas from '../../components/Descargas';
import { DocumentRepository2 } from '../../components/DocumentRepository';
import Hero from '../../components/Hero';

import { motion, AnimatePresence } from "framer-motion";
import { FaFilePdf, FaProjectDiagram, FaLightbulb, FaClipboardList, FaMap } from "react-icons/fa";

import './Lagunas.css';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { 
  Home as HomeIcon,
  MapPin as MapPinIcon,
  FileText as FileTextIcon,
  Phone as PhoneIcon,
  ChevronDown,
  ChevronRight,
  Menu,
  X,
  ExternalLink,
  Subtitles,
  Users,
  Map,
  Landmark,
  Calendar,
  MapPin,
  Info,
  MountainSnow,
  Tree,
  TreePineIcon,
  CheckCircle,
  Compass,
  GlobeIcon,
  DownloadCloud,
  ArrowDown,
  FileText,
  ClockIcon,
  FileSignature,
  FileSpreadsheet,
  Zap,
  BarChart3,
  Book,
  Target,LayersIcon,CircleOff 
} from 'lucide-react';


const FullWidthVisorWithSidebar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeTab, setActiveTab] = useState('uga');

  return (
    <section id="visor-completo" className="py-16">
      <div className="max-w-[2000px] mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            <span className="bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">
              Plataforma Geoespacial Completa
            </span>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">
            Sistema de información geográfica integrado con documentación técnica completa
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          {/* Sidebar - Ancho fijo */}
          <motion.div
            initial={{ x: -20, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            className={`lg:w-96 ${sidebarOpen ? 'block' : 'hidden lg:block'}`}
          >
            <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-xl border border-gray-100 dark:border-gray-700 sticky top-6">
              {/* Botón toggle para móviles */}
              <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="lg:hidden mb-4 w-full p-2 bg-gradient-to-r from-blue-500 to-teal-500 
                  text-white rounded-lg flex items-center justify-center gap-2"
              >
                {sidebarOpen ? 'Ocultar Panel' : 'Mostrar Panel'}
                <ChevronRight className={`w-4 h-4 transition-transform ${sidebarOpen ? 'rotate-90' : ''}`} />
              </button>

              {/* Tabs de navegación */}
              <div className="flex mb-6 bg-gray-100 dark:bg-gray-700 rounded-lg p-1">
                <button
                  onClick={() => setActiveTab('uga')}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${
                    activeTab === 'uga'
                      ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                  }`}
                >
                  Clasificación UGA
                </button>
                <button
                  onClick={() => setActiveTab('descripcion')}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${
                    activeTab === 'descripcion'
                      ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                  }`}
                >
                  Descripción UGA
                </button>
                <button
                  onClick={() => setActiveTab('politica')}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${
                    activeTab === 'politica'
                      ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                  }`}
                >
                  Política Ambiental
                </button>
              </div>

              {/* Contenido según tab activo */}
              <AnimatePresence mode="wait">
                <motion.div
                  key={activeTab}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="space-y-6"
                >
                  {activeTab === 'uga' && (
                    <>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                          <LayersIcon className="w-5 h-5 text-blue-500 mr-2" />
                          Clasificación de UGAs
                        </h3>
                        <img
                          src="/images/clave_uga_region_lagunas.png"
                          alt="Clasificación de Unidades de Gestión Ambiental"
                          className="w-full h-auto rounded-lg shadow-md mb-4"
                        />
                        <p className="text-sm text-gray-600 dark:text-gray-300">
                          Mapa de clasificación de las Unidades de Gestión Ambiental (UGAs) 
                          de la región Lagunas.
                        </p>
                      </div>
                    </>
                  )}

                  {activeTab === 'descripcion' && (
                    <>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                          <Info className="w-5 h-5 text-teal-500 mr-2" />
                          Descripción de las UGAs
                        </h3>
                        <p className="text-gray-600 dark:text-gray-300 mb-4">
                          Las <strong>Unidades de Gestión Ambiental (UGAs)</strong> son la unidad mínima 
                          del territorio a la que se asignan determinados lineamientos y estrategias 
                          ecológicas para su manejo específico.
                        </p>
                        
                        <div className="space-y-4">
                          <div className="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 
                            rounded-lg p-4">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-2">Características</h4>
                            <ul className="text-sm text-gray-600 dark:text-gray-300 space-y-1">
                              <li>• Unidad territorial homogénea</li>
                              <li>• Criterios específicos de manejo</li>
                              <li>• Estrategias ecológicas definidas</li>
                              <li>• Monitoreo individualizado</li>
                            </ul>
                          </div>
                          
                          <div className="bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 
                            rounded-lg p-4">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-2">Objetivos</h4>
                            <ul className="text-sm text-gray-600 dark:text-gray-300 space-y-1">
                              <li>• Gestión ambiental específica</li>
                              <li>• Aplicación de lineamientos</li>
                              <li>• Evaluación de resultados</li>
                              <li>• Adaptación de estrategias</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {activeTab === 'politica' && (
                    <>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                          <Target className="w-5 h-5 text-purple-500 mr-2" />
                          Política Ambiental
                        </h3>
                        <p className="text-gray-600 dark:text-gray-300 mb-4 text-justify">
                          El presente <strong>Modelo de Ordenamiento Ecológico y Territorial Regional</strong> considera una zonificación, integrada por políticas que buscan definir el estado deseable del territorio mediante lineamientos, estrategias y criterios para conservar y controlar el deterioro del ambiente así como el aprovechamiento sustentable de los recursos naturales.
                        </p>
                      </div>
                    </>
                  )}
                </motion.div>
              </AnimatePresence>

              {/* Botones de acción */}
              <div className="mt-8 pt-6 border-t border-gray-100 dark:border-gray-700">
                <div className="grid grid-cols-1 gap-3">
                  <a
                    href="https://siga.jalisco.gob.mx/ordenamiento/visores/visorPaisajeAgavero/index.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 py-2.5 bg-gradient-to-r from-blue-500 to-teal-500 text-white 
                      rounded-lg text-sm font-medium text-center hover:shadow-lg transition-all"
                  >
                    <ExternalLink className="w-4 h-4 inline mr-1" />
                    Abrir en Nueva Ventana
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Visor - Ocupa el resto del espacio */}
          <div className="flex-1">
            <div className="bg-gray-900 rounded-2xl overflow-hidden shadow-2xl">
              <div className="p-4 bg-gradient-to-r from-gray-800 to-gray-900 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-r from-blue-500 to-teal-500 rounded-lg">
                    <GlobeIcon className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white">Visor GIS Region Lagunas</h3>
                    <p className="text-sm text-gray-400">Sistema interactivo de información geográfica</p>
                  </div>
                </div>
              </div>
              
              <div className="h-[600px]">
                <iframe
                  src="https://siga.jalisco.gob.mx/ordenamiento/visores/visorLagunas/index.html"
                  className="w-full h-full border-0"
                  title="Visor GIS Region Lagunas"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};


  const ModernBanner = ({ onScrollClick }) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth) * 100;
      const y = (e.clientY / window.innerHeight) * 100;
      setMousePosition({ x, y });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const stats = [
    { value: '8', label: 'Municipios', icon: MapPin },
    { value: '15,842', label: 'km²', icon: Map },
    { value: '2024', label: 'Inicio', icon: Calendar },
    { value: 'No Vigente', label: 'Estado', icon: CircleOff  },
  ];

  

  return (
    <section className="relative h-screen min-h-[780px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="images/Lagunas.jpeg"
          alt="Paisaje Lagunas"
          className="w-full h-full object-cover"
          style={{
            transform: `translate(${mousePosition.x * 0.01}px, ${mousePosition.y * 0.01}px)`,
            transition: 'transform 0.1s ease-out'
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950/80 via-slate-950/60 to-slate-950/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950/20 via-transparent to-slate-950/10" />
      </div>

      <div className="relative z-10 h-full flex items-center px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto w-full">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <div className="mb-6">
                <StatusBadge />
              </div>

              <h1 className="text-5xl md:text-7xl font-black text-white mb-6 leading-tight">
                <span className="bg-gradient-to-r from-cyan-400 to-emerald-400 bg-clip-text text-transparent">
                  Región Lagunas
                </span>
              </h1>

              <p className="text-xl text-gray-200 mb-8 max-w-xl">
                Estrategia integral para la gestión sustentable del territorio, equilibrando el desarrollo humano con la preservación de los ecosistemas de la región.
              </p>

              <div className="flex flex-wrap gap-4">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  onClick={() => onScrollClick('introduccion')}
                  className="px-8 py-4 bg-gradient-to-r from-cyan-500 to-emerald-500 text-white rounded-xl font-semibold hover:shadow-2xl transition-all"
                >
                  Explorar Región
                </motion.button>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="hidden lg:grid grid-cols-2 gap-4"
            >
              {stats.map((stat, index) => {
                const Icon = stat.icon;
                return (
                  <div key={index} className="text-center">
                    <Icon className="mx-auto mb-2 text-cyan-200" size={24} />
                    <div className="text-2xl font-bold text-white mb-1">{stat.value}</div>
                    <div className="text-xs text-white/70 tracking-wide">{stat.label}</div>
                  </div>
                );
              })}
            </motion.div>
          </div>
        </div>
      </div>

      <motion.div
        animate={{ y: [0, 8, 0] }}
        transition={{ duration: 3, repeat: Infinity }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20"
      >
        <ArrowDown className="text-cyan-400" size={32} />
      </motion.div>
    </section>
  );
};
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

const DetailBadge = ({ icon: Icon, label, value }) => (
  <div className="flex items-center p-3 bg-gray-50 dark:bg-gray-700 rounded-xl transition-all hover:bg-teal-100 dark:hover:bg-teal-900/30">
    <Icon className="text-teal-600 dark:text-teal-400 mr-3 flex-shrink-0" size={20} />
    <div className="text-sm">
      <span className="font-semibold text-gray-700 dark:text-gray-300 block leading-tight">{label}:</span>
      <span className="text-gray-900 dark:text-white font-bold">{value}</span>
    </div>
  </div>
);

const Items = [
  {
    title: "Archivos Vectoriales",
    description: "Archivos geoespaciales para la consulta SIG.",
    imageUrl: "images/vectoriales.png", // sky-600
    baseColor: "sky",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Descargas/vectoriales_Lagunas.zip",

    target: "_blank",
  },
  {
    title: "Fichas UGAS",
    description: "Informacion detallada de cada Unidad de Gestión Ambiental (UGA).",
    imageUrl: "images/FICHAS_UGA.png", // green-600
    baseColor: "green",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Descargas/Fichas%20de%20las%20Unidades%20de%20Gesti%C3%B3n%20Ambiental%20Regi%C3%B3n%20Lagunas.pdf",
    target: "_blank",
  },
  {
    title: "Criterios",
    description: "Regulaciones ecológicas para la preservación y restauración del territorio.",
    imageUrl: "images/Criterios.png", // orange-600
    baseColor: "orange",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Descargas/Criterios%20de%20regulaci%C3%B3n%20ecol%C3%B3gica%20Regi%C3%B3n%20Lagunas.pdf",
    target: "_blank",
  },
  {
    title: "Estrategias Ecologicas",
    description: "Proyectos de orientación para la protección del entorno natural.",
    imageUrl: "images/Estrategias.png", // red-600
    baseColor: "red",    
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Descargas/Proyectos%20estrat%C3%A9gicos%20Regi%C3%B3n%20Lagunas%20(1).pdf",


    target: "_blank",
  },
  {
    title: "Lineamientos",
    description: "Conservar, proteger y restaurar los recursos naturales de la región.",
    imageUrl: "images/Lineamientos.png", // indigo-600
    baseColor: "indigo",
    
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Descargas/Lineamientos%20ecol%C3%B3gicos%20Regi%C3%B3n%20Lagunas.pdf",
    target: "_blank",
  },
  {
    title: "Compatibilidades",
    description: "Guia de compatibilidad de  usos del suelo estratégicos.",
    imageUrl: "images/Compatibilidades.png", // teal-600
    baseColor: "teal",
    
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Descargas/Listado%20de%20usos%20y%20actividades%20sujetos%20a%20controles%20ambientales%20Regi%C3%B3n%20Lagunas.pdf",
    target: "_blank",
  },
];

const items = [
  {
    title: "Archivos Vectoriales",
    description: "Formatos editables y mapas en alta calidad.",
     img: <img src="images/vectoriales.png" alt="Archivos Vectoriales" className="w-16 h-16 mb-4" />,
    icon: <FaMap className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Descargas/vectoriales_Lagunas.zip",
    target: "_blank",
  },
  {
    title: "Fichas",
    description: "Documentos descriptivos y técnicos.",
    img: <img src="images/FICHAS_UGA.png" alt="Fichas" className="w-16 h-16 mb-4" />,
    icon: <FaClipboardList className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Descargas/Fichas%20de%20las%20Unidades%20de%20Gesti%C3%B3n%20Ambiental%20Regi%C3%B3n%20Lagunas.pdf",
    target: "_blank",
  },
  {
    title: "Criterios",
    description: "Lineamientos técnicos y normativos.",
    img: <img src="images/Criterios.png" alt="Criterios" className="w-16 h-16 mb-4" />,
    icon: <FaFilePdf className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Descargas/Criterios%20de%20regulaci%C3%B3n%20ecol%C3%B3gica%20Regi%C3%B3n%20Lagunas.pdf",
  },
  {
    title: "Estrategias",
    description: "Propuestas y planes de acción.",
     img: <img src="images/Estrategias.png" alt="Estrategias" className="w-16 h-16 mb-4" />,
    icon: <FaProjectDiagram className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Descargas/Evaluaci%C3%B3n%20estrat%C3%A9gica%20ambiental%20Regi%C3%B3n%20Lagunas.pdf",
  },
  {
    title: "Lineamientos",
    description: "Guías de aplicación práctica.",
     img: <img src="images/Lineamientos.png" alt="Lineamientos" className="w-16 h-16 mb-4" />,
    icon: <FaLightbulb className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Descargas/Lineamientos%20ecol%C3%B3gicos%20Regi%C3%B3n%20Lagunas.pdf",
  },
  {
    title: "Usos y Actividades",
    description: "Sujetos a controles ambientales en la región.",
    img: <img src="images/Lineamientos.png" alt="Programa de Ordenamiento" className="w-16 h-16 mb-4" />,
    icon: <FaFilePdf className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Descargas/Listado%20de%20usos%20y%20actividades%20sujetos%20a%20controles%20ambientales%20Regi%C3%B3n%20Lagunas.pdf",
  },
];

const LagunasMain = [
  {
    id: 0,
    title: 'Publicación en Periódico Oficial',
    subtitle: 'Decreto y publicación del POETR',
    category: 'Documentos Principales Lagunas',
    icon: <Book className="w-5 h-5 text-green-400" />,
    url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Descargas/Peri%C3%B3dico%20oficial%20Programa%20Ordenamiento%20Ecologico%20Territorial%20Regi%C3%B3nal%20Lagunas%202025.pdf'
  },
  {
    id: 1,
    title: 'POETR Región Lagunas',
    subtitle: 'Programa de Ordenamiento Ecológico y Territorial Regional',
    category: 'Documentos Principales Lagunas',
    icon: <Map className="w-5 h-5 text-emerald-400" />,
    url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Descargas/Programa%20de%20Ordenamiento%20Ecol%C3%B3gico%20Regi%C3%B3n%20Lagunas%202025.pdf'
  },
  {
    id: 2,
    title: 'Plan Regional de Integración Urbana',
    subtitle: 'Desarrollo urbano integral de la región',
    category: 'Documentos Principales Lagunas',
    icon: <Target className="w-5 h-5 text-rose-400" />,
    url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Descargas/Plan%20Regional%20de%20Integraci%C3%B3n%20Urbana%20Regi%C3%B3n%20Lagunas%202025.pdf'
  }
];

const StatusBadge = () => {
  return (
    <motion.div 
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      className="inline-flex items-center px-4 py-2 rounded-full bg-gradient-to-r from-emerald-500/20 to-teal-500/20 
        backdrop-blur-md border border-emerald-500/30"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <div className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse mr-2" />
      <span className="text-sm font-medium text-white tracking-wider">FASE </span>
      <div className="ml-2 pl-2 border-l border-white/20">
        <span className="text-xs text-white/70">En Expedición </span>
      </div>
    </motion.div>
  );
};
const imageList = [
    {
        id: '1',
        src: 'images/Escudo_Amatitán.png',
        thumbnail: 'images/Escudo_Amatitán.png',
        alt: 'Paisaje con montañas',
        caption: 'Amatitán.'
    },
    {
        id: '2',
        src: 'images/tomatlan-escudo.png',
        thumbnail: 'images/tomatlan-escudo.png',
        alt: 'Ciudad nocturna',
        caption: 'Tomatlán.'
    },
    {
        id: '3',
        src: 'images/la_huerta-escudo.png',
        thumbnail: 'images/la_huerta-escudo.png',
        alt: 'Bosque en otoño',
        caption: 'La Huerta.'
    },
    {
        id: '4',
        src: 'images/cihuatlan-escudo.png',
        thumbnail: 'images/cihuatlan-escudo.png',
        alt: 'Playa tropical',
        caption: 'Cihuatlán.'
    },
    
];

const ModernBitacoraSection = ({ items }) => {
  const [expandedSection, setExpandedSection] = useState(0);

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white dark:from-gray-900 dark:to-gray-800" id="bitacora">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            <span className="bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">
              Bitácora del Programa
            </span>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            Registro documental completo del proceso de ordenamiento ecológico
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {items.map((item, index) => {
            const Icon = item.icon;
            return (
              <motion.button
                key={index}
                onClick={() => setExpandedSection(expandedSection === index ? null : index)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className={`p-6 rounded-2xl transition-all duration-300 text-left ${
                  expandedSection === index
                    ? `bg-gradient-to-br ${item.color} text-white shadow-2xl`
                    : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 shadow-lg hover:shadow-xl'
                }`}
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className={`p-3 rounded-xl ${
                    expandedSection === index
                      ? 'bg-white/20'
                      : `bg-gradient-to-br ${item.color}`
                  }`}>
                    <Icon className="w-6 h-6" />
                  </div>
                  <h3 className="text-lg font-semibold">{item.title}</h3>
                </div>
                <p className={`text-sm ${
                  expandedSection === index ? 'text-white/90' : 'text-gray-500 dark:text-gray-400'
                }`}>
                  {expandedSection === index ? 'Ver documentos ↓' : 'Ver documentos →'}
                </p>
              </motion.button>
            );
          })}
        </div>

        <AnimatePresence>
          {expandedSection !== null && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.3 }}
              className="overflow-hidden"
            >
              <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-xl border border-gray-100 dark:border-gray-700">
                {items[expandedSection].content.map((section, sectionIndex) => (
                  <div key={sectionIndex} className="mb-8 last:mb-0">
                    <h4 className="text-xl font-semibold text-gray-900 dark:text-white mb-6 flex items-center">
                      <div className="w-3 h-3 bg-gradient-to-r from-blue-500 to-teal-500 rounded-full mr-3" />
                      {section.subtitle}
                    </h4>
                    <div className="grid md:grid-cols-2 gap-4">
                      {section.items.map((doc, docIndex) => (
                        <a
                          key={docIndex}
                          href={doc.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="group p-4 bg-gray-50 dark:bg-gray-700 rounded-xl hover:bg-gradient-to-r hover:from-blue-50 hover:to-teal-50 
                            dark:hover:from-blue-900/20 dark:hover:to-teal-900/20 transition-all duration-300"
                        >
                          <div className="flex items-center gap-3">
                            <FileText className="w-5 h-5 text-blue-500 group-hover:text-teal-500 transition-colors" />
                            <span className="text-gray-700 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-white">
                              {doc.text}
                            </span>
                          </div>
                        </a>
                      ))}
                    </div>
                  </div>
                ))}
                
                <div className="mt-8 pt-6 border-t border-gray-100 dark:border-gray-700">
                  <p className="text-sm text-gray-500 dark:text-gray-400 text-center">
                    {items[expandedSection].content.reduce((total, section) => total + section.items.length, 0)} documentos disponibles
                  </p>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};

// Datos de los municipios
const municipalities = [
  {
    id: 1,
    name: 'Acatlán de Juárez',
    shield: 'images/Lagunas/Escudo_Acatlan_de_Juarez.png',
    description: 'Con agricultura de temporal enfocada en maíz y frijol, y ganadería extensiva, el municipio se ubica en valles y lomeríos con arroyos estacionales que permiten riego complementario. Sus áreas naturales favorecen la observación de aves.',
    population: '25,250 habitantes',
    area: '160.7 km²',
    foundation: '1891',
    attractions: 'Río Acatlán, presas como Hurtado y parajes como Charco Verde y Cajón del Muerto destacan por sus paisajes, junto a zonas boscosas en el cerro de la Coronilla. El mirador de Santa Cruz y los balnearios de aguas termales complementan estos atractivos naturales ideales para recreación.',
    color: 'from-blue-500 to-teal-600',
    administrativeRegion: 'Sur',
    EcologicaZona: 'Cuenca Alta Costa Sur',
    NumerodeUgas: '5 Unidades de Gestión Ambiental (UGA)',

  },
  {
    id: 2,
    name: 'Amacueca',
    shield: 'images/Lagunas/Escudo_Amacueca.png',
    description: 'Destacado por la producción de maíz, frijol y hortalizas en tierras de riego, complementada con ganadería bovina. Su territorio incluye llanuras y valles con suelos volcánicos y vegetación ribereña, lo que permite el ecoturismo rural y prácticas de conservación.',
    population: '5,743 habitantes',
    area: '124.8 km²',
    foundation: '1877',
    attractions: 'Manantiales como Las Moreras y San Juan Amacueca, junto a paisajes serranos hacia Tapalpa con bosques de pino y encino, conforman sus principales atractivos naturales. Estos entornos se complementan con arquitectura religiosa del siglo XVIII, que aporta un valor histórico al recorrido turístico.',
    color: 'from-green-500 to-emerald-600',
    administrativeRegion: 'Sur',
    EcologicaZona: 'Sitio RAMSAR Laguna de Sayula.',
    NumerodeUgas: '7 Unidades de Gestión Ambiental (UGA)',
  },
  {
    id: 3,
    name: 'Atoyac',
    shield: 'images/Lagunas/Escudo_Atoyac.png',
    description: 'Con agricultura de riego enfocada en caña de azúcar y hortalizas, y ganadería menor, el municipio se desarrolla en valles atravesados por ríos intermitentes. Estas condiciones favorecen el turismo rural.',
    population: '8,689 habitantes',
    area: '451.5 km²',
    foundation: '1886',
    attractions: 'El río Atoyac, los manantiales de Agua Azul y Atotonilco, y los paisajes boscosos de la Sierra del Tigre destacan como atractivos naturales, junto a vistas de la laguna de Sayula y El Salto del Agua. Se complementan con edificaciones como la Parroquia del Señor de la Salud y su kiosco histórico.',
    color: 'from-amber-500 to-orange-600',
    administrativeRegion: 'Sur',
    EcologicaZona: 'Sitio RAMSAR Laguna de Sayula.',
    NumerodeUgas: '13 Unidades de Gestión Ambiental (UGA)',
  },
  {
    id: 4,
    name: 'Sayula',
    shield: 'images/Lagunas/Escudo_Sayula.png',
    description: 'Sustentado en agricultura de riego de caña de azúcar y maíz, y ganadería menor, se localiza en valles atravesados por el río Sayula y zonas de pastizal natural. Estas características permiten el turismo rural y la implementación de técnicas locales de manejo sostenible.',
    population: '37,186 habitantes',
    area: '216 km²',
    foundation: '1824',
    attractions: 'Paisajes ligados a la Laguna de Sayula, arroyos y vegetación de encino, pino y mezquite destacan su riqueza natural. Se complementa con un patrimonio histórico notable, como el templo de La Inmaculada Concepción y antiguos conventos y capillas que evocan su pasado cultural.',
    color: 'from-purple-500 to-indigo-600',
    administrativeRegion: 'Sur',
    EcologicaZona: 'Sitio RAMSAR Laguna de Sayula.',
    NumerodeUgas: '7 Unidades de Gestión Ambiental (UGA)',
  },
  {
    id: 5,
    name: 'Techaluta de Montenegro',
    shield: 'images/Lagunas/Escudo_Techaluta_de_Montenegro.png',
    description: 'Sustentado en agricultura de temporal y ganadería, destaca por la producción de maíz y frijol en lomeríos y valles con suelos volcánicos. Su territorio incluye arroyos estacionales y pastizales que facilitan el ecoturismo rural.',
    population: '4,072 habitantes',
    area: '79.2 km²',
    foundation: '1888',
    attractions: 'Arroyos como Seco y La Morenita, la ribera de la Laguna de Sayula y los bosques de pino, roble y encino en la Sierra de Tapalpa conforman sus principales atractivos, junto con las cuevas de Techaluta y las vistas del Cerro del Gavilán.',
    color: 'from-purple-500 to-indigo-600',
    administrativeRegion: 'Sur',
    EcologicaZona: 'Sitio RAMSAR Laguna de Sayula.',
    NumerodeUgas: '7 Unidades de Gestión Ambiental (UGA)',
  },
  {
    id: 6,
    name: 'Teocuitatlán de Corona',
    shield: 'images/Lagunas/Escudo_Teocuitatlan_de_Corona.png',
    description: 'Con agricultura de temporal orientada a maíz y frijol, y ganadería extensiva, el municipio se encuentra en valles con vegetación riparia y suelos fértiles. Su entorno natural favorece la observación de flora y fauna local.',
    population: '11,039 habitantes',
    area: '334.4 km²',
    foundation: '1844',
    attractions: 'Paisajes naturales ligados al río Teocuitatlán, arroyos y manantiales como Atotonilco, además de presas y la ribera de la Laguna de Sayula. Se complementa con atractivos históricos como la Parroquia de San Miguel Arcángel y edificaciones religiosas tradicionales.',
    color: 'from-pink-500 to-rose-600',
    administrativeRegion: 'Sur',
    EcologicaZona: 'Sitio RAMSAR Laguna de Sayula.',
    NumerodeUgas: '8 Unidades de Gestión Ambiental (UGA)',
  },
  {
    id: 6,
    name: 'Villa Corona', 
    shield: 'images/Lagunas/Escudo_Villa_Corona.png',
    description: 'Destacado por la producción de maíz y caña en tierras de riego, complementada con ganadería menor, se ubica en llanuras y valles atravesados por ríos temporales. Sus áreas naturales facilitan el ecoturismo rural.',
    population: '19,063 habitantes',
    area: '318.2 km²',
    foundation: '1918',
    attractions: 'Balnearios de aguas termales como Chimulco, Agua Caliente y El Tular destacan junto a la Laguna de Atotonilco y zonas boscosas con paisajes rurales. Se suma el singular Puerto de Lourdes, una antigua mina adaptada con capilla y espacios que aportan un toque histórico-cultural.',
    color: 'from-red-500 to-red-600',
    administrativeRegion: 'Sur',
    EcologicaZona: 'Sitio RAMSAR Laguna de Atotonilco.',
    NumerodeUgas: '14 Unidades de Gestión Ambiental (UGA)',
  },
  {
    id: 7,
    name: 'Zacoalco de Torres',
    shield: 'images/Lagunas/Escudo_Zacoalco_de_Torres.png',
    description: 'Con agricultura de riego enfocada en hortalizas y maíz, y ganadería bovina, el municipio se desarrolla en llanuras con arroyos temporales que permiten riego agrícola. Su territorio favorece la observación de especies locales.',
    population: '30,472 habitantes',
    area: '472.4 km²',
    foundation: '1844',
    attractions: '"Bosques de pino y encino en los cerros Guayola y Las Canoas, junto a los paisajes de las lagunas de Zacoalco y San Marcos, son sus principales atractivos naturales. Se suma el toque cultural de la Parroquia de San Francisco y capillas históricas que complementan la visita.',
    color: 'from-yellow-500 to-yellow-600',
    administrativeRegion: 'Sur',
    EcologicaZona: 'Sitio RAMSAR Laguna de Sayula.',
    NumerodeUgas: '10 Unidades de Gestión Ambiental (UGA)',
  }
];



const LagunasPage = () => {
  const [selectedMunicipality, setSelectedMunicipality] = useState(municipalities[0]);
  const aboutContent = `

  <h2 class="text-2xl font-bold mb-4">Ordenamiento Ecológico Regional Lagunas</h2>

    <p class= "text-justify" >El Gobierno del Estado de Jalisco impulsa el desarrollo sustentable en la región denominada Lagunas, integrada por los municipios de Acatlán de Juárez, Amacueca, Atoyac, Sayula, Techaluta de Montenegro, Teocuitatlán de Corona, Villa Corona y Zacoalco de Torres.  Para impulsar dicho desarrollo, el día 16 de enero del 2024 el Gobierno del Estado de Jalisco y los municipios firmaron un Convenio de Coordinación que garantiza la realización de las actividades programadas. Se trata de una colaboración que involucra por igual a los diferentes órdenes de gobierno: Estado y Municipios. El objeto del convenio consistió en establecer las bases para el proceso destinado a la elaboración del ordenamiento territorial. </p>

    <p class= "text-justify" >
Asimismo, se firmó con la Federación un Convenio Marco de Coordinación junto con SEMARNAT Y SEDATU de fecha el 27 de enero de 2020.  Estos convenios establecen los fundamentos para la colaboración en el proceso de elaboración de los siguientes instrumentos de ordenamiento territorial.</p>
  <p class= "text-justify" >
Derivado de esto se inició con el proceso de elaboración de los instrumentos, seguido por el proceso de consulta, la cual incluyó amplia participación de los sectores que influyen en el territorio. Las fechas más relevantes sobre el proceso de elaboración se describen a continuación:


    </p>
    <br>
    
  `;

  const aboutLinks = [
    
     { text: 'Programa de Ordenamiento Ecológico y Territorial Regional', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Descargas/Programa%20de%20Ordenamiento%20Ecol%C3%B3gico%20Regi%C3%B3n%20Lagunas%202025.pdf' },
     { text: 'Plan Regional de Integración Urbana -', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Descargas/Plan%20Regional%20de%20Integraci%C3%B3n%20Urbana%20Regi%C3%B3n%20Lagunas%202025.pdf' },
    { text: 'Programas Municipales de Desarrollo Urbano (Ver en Inicio)', url: '/descargas/tapalpa' },

  ];

  const aboutDates = [
    // { label: 'Inicio de proceso de formulación', date:  '22 de noviembre de 2022' },
    // { label: 'Inicio de Consulta Pública', date: '01 de febrero 2023' },
    // { label: 'Fin de Consulta Pública', date: '31 de mayo 2023' },
    // { label: 'Sesión de validación', date: ' 5 de octubre de 2023' },
    //{ label: 'Fecha Publicación', date: '28 de septiembre de 2024' },
  ];
  const bitacoraItems = [
    {
      title: 'FASE DE FORMULACIÓN',
      icon: FileSignature,
      color: 'from-blue-500 to-cyan-500',
      content: [
        {
          subtitle: 'Acuerdos de Integración Municipal',
          items: [
            { text: 'Acuerdo de integración - Acatlán de Juárez', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/gestion/01_Acatlan_de_Juarez_Punto_de_acuerdo.pdf' },
            { text: 'Acuerdo de integración - Amacueca', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/gestion/02_Amacueca_Punto_de_acuerdo.pdf' },
            { text: 'Acuerdo de integración - Atoyac', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/gestion/03_Atoyac_Punto_de_acuerdo.pdf' },
            { text: 'Acuerdo de integración - Techaluta de Montenegro', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/gestion/05_Techaluta_Punto_de_acuerdo.pdf' },
            { text: 'Acuerdo de integración - Teocuitatlán de Corona', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/gestion/06_Teocuitatlan_de_Corona_Punto_de_%20acuerdo.pdf' },
            { text: 'Acuerdo de integración - Villa Corona', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/gestion/07_Villa_Corona_Punto_de_acuerdo.pdf' },
            { text: 'Acuerdo de integración - Zacoalco de Torres', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/gestion/08_Zacoalco_de_Torres_Punto_de_acuerdo.pdf' },
            { text: 'Acuerdo de integración - Sayula', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/gestion/Acuerdo_de_integracion_Sayula.pdf' },
          ]
        },
        {
          subtitle: 'Reuniones de Trabajo',
          items: [
            { text: 'Lista de asistencia CONAGUA-PRODEUR-Acatlán de Juárez-SEMADET', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/gestion/Lista_de_asistencia_CONAGUA_PRODEUR_Acatlan_de_Juarez_SEMADET.pdf' },
            { text: 'Minuta de trabajo CONAGUA-PRODEUR-Acatlán_de_Járez_SEMADET', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/gestion/Minuta_de_trabajo_CONAGUA_PRODEUR_Acatlan_de_Juarez_SEMADET.pdf' },
          ]
        },
        {
          subtitle: 'Convenios',
          items: [
            { text: 'Convenio de Coordinación Estado-Municipios Región Lagunas', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Convenio/Convenio%20de%20Coordinaci%C3%B3n%20Estado-Municipios%20Regi%C3%B3n%20Lagunas%20Peri%C3%B3dico.pdf' },
          ]
        }
      ]
    },
    {
      title: 'FASE DE EXPEDICIÓN',
      icon: FileSpreadsheet,
      color: 'from-emerald-500 to-green-500',
      content: [
        {
          subtitle: 'Consulta y Participación Ciudadana',
          items: [
            { text: 'Consulta Pública Ordenamiento', url: 'https://siga.jalisco.gob.mx/ordenamientosc/lagunas/OrdenamientosLagunas.html' },
            { text: 'Respuestas a las Observaciones de la Consulta Pública', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Elaboracion/Respuestas_Consulta_Publica_Censurado.pdf' },
          ]
        }
      ]
    },
    {
      title: 'FASE DE EJECUCIÓN',
      icon: Zap,
      color: 'from-amber-500 to-orange-500',
      content: [
        {
          subtitle: 'Actas del Consejo Regional',
          items: [
            { text: '01. Instalación y primera sesión ordinaria 2023 - Acta', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/comite/01_Acta_de_instalacion.pdf' },
            { text: '01. Instalación y primera sesión ordinaria 2023 - Lista de asistencia', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/comite/02_Lista_de_asistencia.pdf' },
            { text: '02. Acta primera sesión extraordinaria 2023', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/comite/02_Acta_primera_sesion_extraordinaria_2023.pdf' },
            { text: 'Segunda sesión ordinaria 2024 - Acta', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/comite/ACTA_SEGUNDA_SESION_CR_LAGUNAS_2024_VALIDACION_Censurado.pdf' },
            { text: 'Segunda sesión ordinaria 2024 - Lista de Asistencia', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/comite/LISTA_ASISTENCIA_VALIDACION_CR_LAGUNAS_Censurado.pdf' },
          ]
        }
      ]
    },
    {
      title: 'FASE DE EVALUACIÓN',
      icon: BarChart3,
      color: 'from-purple-500 to-violet-500',
      content: [
        {
          subtitle: 'Evaluaciones Programadas',
          items: []
        },
        {
          subtitle: 'Ajustes y Mejoras',
          items: []
        }
      ]
    }
  ];

  return (
    <div className="environmental-theme fade-in">
       <ModernBanner onScrollClick={scrollToSection} />
      {/* Banner Parallax - Versión mejorada */}
      {/* <div className="parallax-container">
        <div 
          className="parallax-banner"
          style={{ backgroundImage: "url('images/Lagunas.jpeg')" }}
        >
          <div className="parallax-overlay"></div>
          <div className="parallax-content">
            <h1 className="parallax-title">Región Lagunas</h1>
            <p className="parallax-subtitle">
              Ordenamiento territorial y desarrollo sustentable
            </p>
          </div>
        </div>
      </div> */}
      <section id="introduccion" className="py-16">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="bg-gradient-to-br from-white to-gray-50 dark:from-gray-800 dark:to-gray-900 
                rounded-2xl p-8 shadow-xl border border-gray-100 dark:border-gray-700"
            >
              <div className="flex flex-col lg:flex-row items-start gap-8">
                <div className="lg:w-2/3">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="p-2 bg-gradient-to-r from-blue-500 to-teal-500 rounded-lg">
                      <Info className="w-5 h-5 text-white" />
                    </div>
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                      Ordenamiento Ecológico Regional
                      <span className="block text-lg text-gray-600 dark:text-gray-300 mt-1">
                        Lagunas
                      </span>
                    </h2>
                  </div>
                  
                  <div className="space-y-4 text-gray-700 dark:text-gray-300">
                    <p>
                      El <strong>Gobierno del Estado de Jalisco</strong> impulsa el desarrollo sustentable 
                      en la región denominada <strong>Lagunas</strong>, integrada por los municipios de 
                      <strong> Acatlán de Juárez, Amacueca, Atoyac, Sayula, Techaluta de Montenegro, Teocuitatlán de Corona, Villa Corona y Zacoalco de Torres</strong>.
                    </p>
                    
                    <p>
                      Para impulsar dicho desarrollo, el día <strong>16 de enero del 2024</strong> el Gobierno 
                      del Estado de Jalisco y los municipios firmaron un <strong>Convenio de Coordinación</strong> que 
                      garantiza la realización de las actividades programadas.
                    </p>
                    
                    <p>
                      Se trata de una colaboración que involucra por igual a los diferentes órdenes de gobierno: 
                      <strong> Estado y Municipios</strong>. El objeto del convenio consistió en establecer las bases 
                      para el proceso destinado a la elaboración del ordenamiento territorial.
                    </p>
                    {/* <p>
                       Es importante señalar que, si bien el municipio de Talpa de Allende no suscribió el convenio de colaboración,
                       su territorio sí fue considerado dentro del ámbito de aplicación del ordenamiento toda vez que la regionalización 
                       responde a un sistema de intervención territorial basado en similitudes económicas y territoriales, 
                       así como un enfoque de cuenca orientado a la conservación de los recursos naturales.
                    </p> */}
                    <p>
                     Asimismo, se firmó con la Federación un <strong>Convenio Marco de Coordinación</strong> junto con <strong>SEMARNAT Y SEDATU</strong>
                     de fecha el 27 de enero de 2020. Estos convenios establecen los fundamentos para la colaboración en el proceso de elaboración de los siguientes instrumentos de ordenamiento territorial.
                    </p>
                    <p>
                     
                     Derivado de esto se inició con el proceso de elaboración de los instrumentos, seguido por el <strong> proceso de consulta </strong>, 
                     la cual incluyó amplia participación de los sectores que influyen en el territorio. Las fechas más relevantes sobre 
                     el proceso de elaboración se describen a continuación:
                    </p>
                  </div>
                </div>
                
                {/* <div className="lg:w-1/3">
                  <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-lg border border-gray-100 dark:border-gray-700">
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                      <ClockIcon className="w-5 h-5 text-blue-500 mr-2" />
                      Cronología Clave
                    </h3>
                    <ul className="space-y-3">
                      <li className="flex items-center text-sm">
                        <div className="w-2 h-2 bg-emerald-500 rounded-full mr-3" />
                        <span className="text-gray-700 dark:text-gray-300">
                          <strong>Inicio de proceso de formulación:</strong><br /> 27 de septiembre de 2022
                        </span>
                      </li>
                      <li className="flex items-center text-sm">
                        <div className="w-2 h-2 bg-emerald-500 rounded-full mr-3" />
                        <span className="text-gray-700 dark:text-gray-300">
                          <strong>Inicio de Consulta Pública:</strong><br />22 de junio de 2023
                        </span>
                      </li>
                      <li className="flex items-center text-sm">
                        <div className="w-2 h-2 bg-emerald-500 rounded-full mr-3" />
                        <span className="text-gray-700 dark:text-gray-300">
                          <strong>Fin de Consulta Pública:</strong><br />22 de agosto de 2023
                        </span>
                      </li>
                      <li className="flex items-center text-sm">
                        <div className="w-2 h-2 bg-blue-500 rounded-full mr-3" />
                        <span className="text-gray-700 dark:text-gray-300">
                          <strong>Sesión de validación técnica:</strong><br />26 de enero de 2024
                        </span>
                      </li>
                      <li className="flex items-center text-sm">
                        <div className="w-2 h-2 bg-emerald-500 rounded-full mr-3" />
                        <span className="text-gray-700 dark:text-gray-300">
                          <strong>Fecha Publicación oficial:</strong><br />28 de septiembre de 2024
                        </span>
                      </li>
                    </ul>
                  </div>
                </div> */}
              </div>
            </motion.div>
          </div>
  
        </section>
       {/*AboutSection 
        //title="Ordenamiento Ecológico Regional Lagunas"
        content={aboutContent}
        links={aboutLinks}
        dates={aboutDates}
        phase="Ejecución"
        mainDocumentLink={{
           url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Lagunas/Descargas/Peri%C3%B3dico%20oficial%20Programa%20Ordenamiento%20Ecologico%20Territorial%20Regi%C3%B3nal%20Lagunas%202025.pdf", 
           text: "Publicación en Periódico Oficial"
        //}}
        // mainDocumentLinkR={{
        //   url: "https://periodicooficial.jalisco.gob.mx/sites/periodicooficial.jalisco.gob.mx/files/09-11-2i-vi.pdf", 
        //   text: "Reforma de la Publicación en Periódico Oficial"
        // }}
      ///>*/}

      {/* Nueva sección: Documentos principales Lagunas */}
      <section id="DocumentosE" className="py-16 bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
        <DocumentRepository2
          items={LagunasMain}
          onDownload={(doc) => window.open(doc.url, '_blank')}
          showFooter={false}
        />
      </section>

    <Descargas dataItems={Items} />

<section className="municipalities-section py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-teal-50 to-cyan-100 dark:from-gray-900 dark:to-gray-800 min-h-screen font-sans">
      <div className="container mx-auto max-w-7xl">
        
        {/* --- Título Principal --- */}
        <h2 className="text-4xl md:text-5xl font-extrabold text-teal-800 dark:text-teal-400 text-center mb-16 relative">
          <MapPin className="inline-block mr-3 mb-1 w-10 h-10" />
          Municipios de la Región : Lagunas
          <p className="text-lg font-normal text-gray-600 dark:text-gray-400 mt-2">
            Conoce los municipios y sus características clave.
          </p>
        </h2>
        
        {/* --- Grid de Tarjetas (Selector) --- */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {municipalities.map((municipality) => (
            <div 
              key={municipality.id}
              onClick={() => setSelectedMunicipality(municipality)}
              className={`
                municipality-card 
                rounded-2xl 
                overflow-hidden 
                shadow-xl 
                transition-all 
                duration-500 
                cursor-pointer 
                hover:shadow-2xl 
                hover:scale-[1.03]
                bg-white/90 dark:bg-gray-800/80
                backdrop-blur-sm
                border border-gray-100 dark:border-gray-700
                ${selectedMunicipality.id === municipality.id 
                  ? 'ring-4 ring-teal-500 scale-[1.03] shadow-teal-300/50 dark:shadow-teal-700/50' 
                  : 'hover:ring-2 hover:ring-teal-300'
                }
              `}
            >
              <div className={`h-28 ${municipality.color} flex flex-col items-center justify-center p-3 text-white font-bold`}>
                <img 
                  src={municipality.shield} 
                  alt={`Escudo de ${municipality.name}`} 
                  className="h-14 w-14 object-contain mb-1 drop-shadow-md"
                  onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/64x64/000000/ffffff?text=E"; }}
                />
              </div>
              <div className="p-4">
                <h3 className="text-xl font-extrabold text-center text-gray-900 dark:text-white">{municipality.name}</h3>
                <p className="text-xs text-center text-teal-600 dark:text-teal-400 mt-1 flex items-center justify-center">
                    Ver Detalles <ChevronRight className='w-3 h-3 ml-1'/>
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* --- Detalles del municipio seleccionado (Modern Panel) --- */}
        <div 
            key={selectedMunicipality.id} // Key para forzar la animación en cada selección
            className="municipality-details bg-white dark:bg-gray-800 rounded-3xl shadow-2xl p-8 md:p-12 max-w-6xl mx-auto border border-teal-200 dark:border-teal-900 animate-fade-in-up"
            style={{ '--delay': '200ms' }}
        >
          <div className="flex flex-col md:flex-row items-start gap-10">
            
            {/* Escudo y Descripción */}
            <div className="w-full md:w-1/3 flex flex-col items-center justify-center p-4 bg-gray-50 dark:bg-gray-700 rounded-xl">
              <img 
                src={selectedMunicipality.shield} 
                alt={`Escudo de ${selectedMunicipality.name}`} 
                className="h-48 w-48 object-contain shadow-lg rounded-full p-2 bg-white dark:bg-gray-900 mb-6 border-4 border-teal-300 dark:border-teal-500"
                onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/192x192/000000/ffffff?text=E"; }}
              />
              <h3 className="text-3xl font-bold mb-2 text-gray-900 dark:text-white text-center">{selectedMunicipality.name}</h3>
              <p className="text-gray-600 dark:text-gray-400 text-sm text-center italic mt-2">{selectedMunicipality.description}</p>
            </div>
            
            {/* Información Detallada (Badges) */}
            <div className="w-full md:w-2/3">
                
                <h4 className="text-2xl font-bold text-teal-700 dark:text-teal-400 mb-6 border-b border-gray-200 dark:border-gray-700 pb-2 flex items-center">
                    <Info className='w-5 h-5 mr-2'/> Datos Clave
                </h4>

                {/* Grid de Métricas */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <DetailBadge icon={Users} label="Población" value={selectedMunicipality.population} />
                    <DetailBadge icon={Map} label="Superficie" value={selectedMunicipality.area} />
                    <DetailBadge icon={Calendar} label="Municipalización" value={selectedMunicipality.foundation} />
                    <DetailBadge icon={Landmark} label="Región Administrativa" value={selectedMunicipality.administrativeRegion} />
                    <DetailBadge icon={MapPin} label="Número de UGAs" value={selectedMunicipality.NumerodeUgas} />
                    <DetailBadge icon={MountainSnow} label="Zonas de Importancia Ecológica" value={selectedMunicipality.EcologicaZona} />
                </div>
                
                {/* Atracciones (Full Width) */}
                <div className="mt-8 pt-4 border-t border-gray-200 dark:border-gray-700">
                    <h4 className="text-xl font-bold text-gray-900 dark:text-white mb-3 flex items-center">
                        <TreePineIcon className='text-blue-500 mr-2 w-5 h-5'/> Principales Atracciones
                    </h4>
                    <p className="text-gray-700 dark:text-gray-300 leading-relaxed bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-100 dark:border-blue-800">
                        {selectedMunicipality.attractions}
                    </p>
                </div>
              
            </div>
          </div>
        </div>
      </div>
    </section>

     {/* <section className="flex flex-col md:flex-row flex-1">
    <aside className="w-full md:w-96 bg-white shadow-2xl border-r border-gray-200 p-6 flex flex-col">
        
          <div className="mb-6">
            <img
              src="/images/Clave_UGA_Region_Lagunas.png"
              alt="Diagrama UGAs"
              className="rounded-xl shadow-md"
            />
          </div>

          
          <div className="mb-6">
            <h2 className="text-xl font-bold text-sky-700 mb-2">
              Descripción de las UGAs
            </h2>
            <p className="text-gray-700 leading-relaxed">
             Unidad mínima del territorio a la que se asignan determinados lineamientos y estrategias ecológicas

            </p>
          </div>

         
          <div>
            <h2 className="text-xl font-bold text-sky-700 mb-4"> Descripción de Política Ambiental:
</h2>
           <p className="text-gray-700 leading-relaxed">
            El presente Modelo de Ordenamiento Ecológico y Territorial Regional considera una zonificación, integrada por cinco políticas que buscan definir el estado deseable del territorio mediante lineamientos, estrategias y criterios para conservar y controlar el deterioro del ambiente así como el aprovechamiento sustentable de los recursos naturales.


            </p>
          </div>
        </aside>
     
      </section> */}
    <FullWidthVisorWithSidebar />
    <ModernBitacoraSection items={bitacoraItems} />  
      <FasesSection 
        imageUrl="images/FasesOrdenamiento.png"
        altText="Fases del Ordenamiento Región Lagunas"
      />
     
    </div>
  );
};

export default LagunasPage;